import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
import React from 'react';
import CrossOutline from '@scaleflex/icons/cross-outline';
import { intrinsicComponent } from '../../utils/functions';
import { Size } from './types';
import Styled from './cross-button.styles';
var getIconSize = function getIconSize(sizeName) {
  switch (sizeName) {
    case Size.Lg:
      return 16;
    case Size.Xs:
      return 10;
    case Size.Sm:
    default:
      return 12;
  }
};
var CrossButton = intrinsicComponent(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? Size.Lg : _ref$size,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Styled.CrossButton, _extends({
    type: "button",
    size: size
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement(CrossOutline, {
    size: getIconSize(size)
  }));
});
export default CrossButton;